const theme = {
  'primaryColor': '#00B9FF',
  'globalHeader': {
    'headerIcon': 'arrow',
  }
}

export { theme }